import AccountSetting from './AccountSetting.class.js'

export {
  // eslint-disable-next-line import/prefer-default-export
  AccountSetting,
}
